import { Button, Dialog, Grid, useTheme, Box } from '@mui/material';
import { $backgroundOffWhite, $black } from 'constants/styles/_colors';
import AloftLogo from 'assets/images/aloft_logo_black.png';
import AirControl from 'assets/images/air_control_black.png';
import { authenticationPagesStyles } from 'constants/styles';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const AccountExpiringDialog = ({ open = false, handleClose }) => {
	const { t } = useTranslation();
	const theme = useTheme();

	const styles = {
		...authenticationPagesStyles(theme),
		main: {
			height: '100%',
			width: '100%',
			overflow: 'auto',
			padding: '40px',
			backgroundColor: $backgroundOffWhite,
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'stretch',
			justifyContent: 'space-between',
			[theme.breakpoints.down('md')]: {
				alignItems: 'center',
				padding: '30px'
			}
		},
		logo: {
			marginBottom: '30px',
			width: '215px'
		},
		airControlLogo: {
			width: '433px',
			marginBottom: '20px',
			[theme.breakpoints.down('md')]: {
				width: '100%'
			}
		},
		title: {
			fontSize: '30px',
			marginBottom: '30px'
		},
		text: {
			fontSize: '20px',
			marginBottom: '30px'
		},
		airControlContainer: {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
			marginBottom: '30px',
			fontWeight: 800,
			[theme.breakpoints.down('md')]: {
				marginBottom: '30px'
			}
		},
		welcome: {
			color: $black,
			fontSize: '50px',
			marginBottom: '15px',
			[theme.breakpoints.down('md')]: {
				display: 'none'
			}
		},
		footerPlaceholder: {
			height: '78px'
		}
	};

	return (
		<Dialog
			fullScreen
			open={open}
			onClose={handleClose}
			PaperProps={{
				sx: styles.dialog
			}}
		>
			<Box sx={styles.main}>
				<Box sx={styles.headerContainer}>
					<Box component={'img'} src={AloftLogo} alt='' sx={styles.logo} />
				</Box>
				<Grid container sx={styles.mainContainer}>
					<Grid item xs={12} sm={12} md={6} sx={styles.leftContainerText}>
						<Box sx={styles.airControlContainer}>
							<Box sx={styles.welcome}>Welcome to</Box>
							<Box component={'img'} src={AirControl} alt='' sx={styles.airControlLogo} />
						</Box>
					</Grid>
					<Grid item xs={12} sm={12} md={6}>
						<Box sx={styles.outlineContainer}>
							<Box sx={styles.title}>Account Expiring Soon</Box>
							<Box sx={styles.text}>
								{t(
									'Our records indicate that your current payment is past due and your subscription will expire soon'
								)}
								. {t('Please contact your Administrator or')}{' '}
								<a href='mailto:support@aloft.ai'>support@aloft.ai</a> {t('to resolve this issue')}.
							</Box>
							<Button variant='contained' onClick={handleClose}>
								{t('Continue')}
							</Button>
						</Box>
					</Grid>
				</Grid>
				<Box sx={styles.footerPlaceholder} />
			</Box>
		</Dialog>
	);
};

AccountExpiringDialog.propTypes = {
	open: PropTypes.bool,
	handleClose: PropTypes.func.isRequired
};

export default AccountExpiringDialog;
